import { SET_BANKING_APPLICATION, SET_BANKING_SECTION } from 'app/actionTypes';
import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useFormNetworkCalls } from 'utils/useFormNetworkCalls';
import FormPageDisplay from './FormPageDisplay';
import {
  ApplicationStatus,
  BankingApplicationDocument,
  DO_APPLICATION_TYPE,
  KYCStatus,
  SubmissionSteps,
} from 'client-experience-toolbox';
import { getFirstIncompleteSection, initAlloy } from 'utils/utils';

export const Banking: FC = () => {
  const { fetchApplication, patchNeuroData } = useFormNetworkCalls(DO_APPLICATION_TYPE.BANKING);
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    const initializeApplication = async () => {
      const bankingApplication = id && ((await fetchApplication(id)) as Partial<BankingApplicationDocument>);
      if (bankingApplication) {
        const firstIncomplete = bankingApplication && getFirstIncompleteSection(bankingApplication);
        const submissionSteps = 'submissionSteps' in bankingApplication ? bankingApplication.submissionSteps : null;

        const alloyResponse = await initAlloy(bankingApplication?.submissionSteps?.journeyApplicationToken);

        const updatedApplication = {
          ...bankingApplication,
          neuroSiteId: alloyResponse?.neuroIdSiteId,
          neuroUserId: alloyResponse?.neuroUserId,
        };

        dispatch({
          type: SET_BANKING_APPLICATION,
          bankingApplication: updatedApplication,
          sectionHasChanged: false,
        });
        dispatch({ type: SET_BANKING_SECTION, bankingSection: firstIncomplete });
        if (bankingApplication?.status !== ApplicationStatus.SUBMITTED) {
          await patchNeuroData(id, updatedApplication?.neuroUserId, updatedApplication?.neuroSiteId);
        } else if (submissionSteps) {
          // Application has already completed atleast step 1 of submitting and the user is possibly returning for KYC/KYB
          const { kycStatus, kybStatus } = submissionSteps as SubmissionSteps;
          if (!kycStatus || kycStatus === KYCStatus.STARTED) {
            dispatch({ type: 'SET_BANKING_SUBMISSION_ERROR', bankingSubmissionError: true });
            dispatch({ type: 'SET_POST_SUBMISSION_STEP', submissionStep: 2 });
          } else if (kycStatus === KYCStatus.APPROVED && (!kybStatus || kybStatus === undefined)) {
            dispatch({ type: 'SET_BANKING_SUBMISSION_ERROR', bankingSubmissionError: true });
            dispatch({ type: 'SET_POST_SUBMISSION_STEP', submissionStep: 3 });
          }
        }
      }
    };
    id && initializeApplication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return <FormPageDisplay type={DO_APPLICATION_TYPE.BANKING} />;
};
